<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <app-form-field-wrapper
    label="Bezeichnung"
    name="title"
    [formField]="form.get('title')">
    <input pInputText id="title" type="text" formControlName="title" />
  </app-form-field-wrapper>

  <app-form-field-wrapper
    label="Quelle"
    name="source"
    [formField]="form.get('source')">
    <input pInputText id="source" type="text" formControlName="source" />
  </app-form-field-wrapper>

  <div class="flex gap-5 align-items-start p-2 pt-6">
    <p-fileUpload
      mode="basic"
      chooseLabel="auswählen & hochladen"
      chooseIcon="pi pi-upload"
      name="imagePool"
      [url]="uploadUrl"
      [auto]="true"
      accept="image/*"
      maxFileSize="5000000"
      invalidFileSizeMessageSummary="Upload fehlgeschlagen!"
      invalidFileSizeMessageDetail="Laden Sie bitte maximal 5MB hoch."
      invalidFileTypeMessageSummary="Upload fehlgeschlagen!"
      invalidFileTypeMessageDetail="Nur Bild-Uploads sind erlaubt."
      (onUpload)="onUpload($event)" />

    @if (this.form.value.src) {
      <div class="p-card p-0 overflow-hidden">
        <div class="h-6rem w-8rem">
          <img
            [ngSrc]="imagePath"
            [alt]="this.form.value.src"
            fill
            priority
            style="
              position: static;
              object-fit: contain;
              object-position: 50% 50%;
            " />
        </div>
      </div>
    }
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (cancel)="onCancel()"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
